import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { IT_SERVICES } from "../data/mock";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export default function ITServices() {
  return (
    <div data-testid="it-services-page" className="pt-16 bg-[#2A0208]">
      <section className="py-24 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <motion.div {...fadeUp} className="max-w-3xl mb-16">
            <p className="uppercase text-xs tracking-[0.2em] text-[#D4A24C] font-semibold mb-4">IT Services</p>
            <h1 className="font-heading text-5xl sm:text-6xl font-light tracking-tight leading-[1.05] text-white">
              Predict the future by <span className="italic text-[#D4A24C]">creating it.</span>
            </h1>
            <p className="mt-6 text-lg text-white/65 leading-relaxed">
              From websites and apps to servers, databases and custom software — the engineering behind ambitious brands. Explore any service to see exactly what's included.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {IT_SERVICES.map((s, i) => (
              <motion.div key={s.slug} {...fadeUp} transition={{ ...fadeUp.transition, delay: (i % 3) * 0.1 }}>
                <Link to={`/it-services/${s.slug}`} data-testid={`it-service-card-${s.slug}`}
                  className="group block bg-white/[0.04] border border-white/10 rounded-2xl overflow-hidden h-full backdrop-blur-sm hover:border-[#D4A24C]/40 transition-colors duration-300">
                  <div className="h-44 overflow-hidden relative">
                    <img src={s.heroImage} alt={s.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#2A0208]/70 to-transparent" />
                    <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-[#2A0208]/80 backdrop-blur border border-white/15 flex items-center justify-center text-[#D4A24C]">
                      <s.icon size={20} />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-heading text-2xl font-semibold text-white">{s.title}</h3>
                    <p className="mt-1 text-sm font-medium text-[#D4A24C]">{s.tagline}</p>
                    <p className="mt-3 text-[15px] text-white/65 leading-relaxed">{s.description}</p>
                    <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-white">
                      Learn more <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-200" />
                    </span>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>

          <motion.div {...fadeUp} className="mt-16 rounded-2xl bg-white/[0.04] border border-white/10 text-white p-10 sm:p-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <h2 className="font-heading text-3xl sm:text-4xl font-light">Have a project in mind?</h2>
              <p className="mt-2 text-white/55">From an idea on paper to a product in production — let's build it.</p>
            </div>
            <Link to="/contact" data-testid="it-services-contact-cta"
              className="inline-flex items-center gap-2 rounded-full bg-[#D4A24C] text-[#2A0208] px-7 py-3.5 font-semibold hover:bg-[#e0b466] transition-colors duration-200 shrink-0">
              Book a Discovery Call <ArrowUpRight size={17} />
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
